/** Case-insensitive substring match; empty query matches everything. */
export function matchesNavQuery(label: string, query: string): boolean {
  const needle = query.trim().toLowerCase();
  if (!needle) return true;
  return label.toLowerCase().includes(needle);
}

export function filterNavItemsByQuery<T extends { label: string }>(
  items: T[],
  query: string
): T[] {
  return items.filter((item) => matchesNavQuery(item.label, query));
}
